/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NbDialogService, NbButtonModule } from "@nebular/theme";

import { NgdHubspotFormDialogComponent } from "../hubspot-form-dialog/hubspot-form-dialog.component";
import { NgFor } from "@angular/common";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "ngd-for-business",
  template: `
    <div class="left">
      <h2 [attr.id]="headingId" class="heading h1 text-control">
        {{ "hhPlatform.home.business.practice" | translate }}
      </h2>
      <button (click)="openDialog()" class="submit" nbButton status="control">
        {{ "hhPlatform.home.business.tryitForFree" | translate }}
      </button>
    </div>

    <div class="right">
      <p class="h6 offerings-title">
        {{ "hhPlatform.home.business.withMedPoc" | translate }}
        <span class="offerings-title-second-line">{{
          "hhPlatform.home.business.easily" | translate
        }}</span>
      </p>

      <ul class="offerings">
        <li class="offering text-hint" *ngFor="let offering of offerings">
          {{ offering }}
        </li>
      </ul>
    </div>
  `,
  exportAs: "ngdForBusiness",
  styleUrls: ["./for-business.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NbButtonModule, NgFor, TranslateModule],
})
export class NgdForBusinessComponent {
  readonly headingId: string = "ngd-for-business-heading";

  offerings: string[] = [];

  constructor(
    private dialogService: NbDialogService,
    public translate: TranslateService
  ) {}

  openDialog(): void {
    const context = {
      title: "Nebular for business",
      formConfig: {
        portalId: "XXXXXXX",
        formId: "40c56c10-9b41-4d12-95dd-e6c186ac4273",
      },
    };

    this.dialogService.open(NgdHubspotFormDialogComponent, { context });
  }

  ngOnInit() {
    const offerTranslationKeys = [
      "hhPlatform.home.business.offerings.first",
      "hhPlatform.home.business.offerings.second",
      "hhPlatform.home.business.offerings.third",
      "hhPlatform.home.business.offerings.fourth",
    ];

    this.translate.get(offerTranslationKeys).subscribe(translation=> {
      this.offerings = [
        translation["hhPlatform.home.business.offerings.first"],
        translation["hhPlatform.home.business.offerings.second"],
        translation["hhPlatform.home.business.offerings.third"],
        translation["hhPlatform.home.business.offerings.fourth"]
      ]
    })
  }
}
